/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import Loader from '../../components/Loader/Loader';
import * as cms from '../../shared/repos/cms/cms';
import cmsKeys from '../../shared/constants/cms';

import styles from './FAQ.module.css'
import CmsInlineEdit from '../../components/Cms/CmsInlineEdit';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import BrandRefreshFaq from '../SecondaryPages/BrandRefreshFaq';
import SecondaryPageEmpty from '../SecondaryPages/SecondaryPageEmpty';

class FAQ extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: [],
            loading: true
        };
    }

    componentDidMount() {
        cms.getContent([cmsKeys.faqPage.faqSections], this);
    }

    render() {
        const { content, loading } = this.state;

        if (isBrandRefreshEnabled()) {
          return (
            <div className={styles.pageWrapper} data-region="secondary-page" data-page="FAQ">
              <h1 data-part="secondary-page-title">Frequently Asked Questions</h1>
              <div data-part="content-surface">
                {loading && !content.length ? <Loader id="loader" /> : null}
                {!loading && !content.length ? <SecondaryPageEmpty /> : null}
                {content.length > 0 ? <BrandRefreshFaq content={content} idPrefix="standalone-faq" /> : null}
              </div>
            </div>
          );
        }

        if (!content.length) {
            return (
              <div className={styles.pageWrapper} data-region="secondary-page" data-page="FAQ">
                <div className={styles.pageContainer} data-part="content-surface">
                  <Loader id="loader" />
                </div>
              </div>
            );
        }

        return (
          <div className={styles.pageWrapper} data-region="secondary-page" data-page="FAQ">
            <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
              {content.map(faqSection => {
                    return (
                      <div>
                        <div className={styles.pageSection} data-part="prose-section">
                          <h1><CmsInlineEdit cmsNode={faqSection}>{faqSection.value}</CmsInlineEdit></h1>
                        </div>

                        {faqSection.children.map(faqQuestion => {
                                return (
                                  <div className={styles.pageSection} data-part="prose-section">
                                    <h3><CmsInlineEdit cmsNode={faqQuestion}>{faqQuestion.value}</CmsInlineEdit></h3>

                                    <div><CmsInlineEdit cmsNode={faqQuestion.children[0]}>{faqQuestion.children[0].value}</CmsInlineEdit></div>
                                  </div>
                                )
                            })}
                      </div>
                    )
                })}
            </div>
          </div>
        );
    }
};

export default FAQ;
